// extracted by mini-css-extract-plugin
module.exports = {"closer":"Closer_closer__jQ_7V"};